// Module
var code = "<div class=\"relative\" data-screen-name=\"PortletScreen\"> <!--ko with: _portletSpace--> <!--ko template: {name: GetTemplateName.bind($data), afterRender: AfterRender.bind($data)}--><!--/ko--> <!--/ko --> </div> ";
// Exports
export default code;